import React, { useState } from 'react'
import { Button, Form, Input } from "antd";
import { changePassword } from '../../../ApiServices/Apifun';
import { dispatchtoast } from '../../../Utils';

const ChangePassword = () => {
    const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const validatePassword = (rule, value) => {
    const { getFieldValue } = form;
    if (value && value !== getFieldValue("new_password")) {
      return Promise.reject("The passwords do not match!");
    }
    return Promise.resolve();
  };
  const handleFinish = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    Object.keys(val).map((key) => formdata.append(key, val[key]));
    changePassword(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          form.resetFields()
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  return (
    <div className="w-full bg-white p-4 rounded-md mt-3 flex justify-start items-start">
    <Form
      form={form}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinishFailed={(err) => console.log(err)}
      onFinish={(val) => handleFinish(val)}
    >
      <Form.Item
        name={`old_password`}
        label={"Old Password"}
        className="w-full"
        labelCol={{ span: 24 }}
        rules={[
          {
            required: true,
            message: "Enter old password!",
          },
          {
            whitespace: true,
            message: "Field cannot contain only blank spaces",
          },
        ]}
      >
        <Input.Password
          placeholder="Enter old password"
          name="old_password"
          className="outline-none text-xs rounded-none border mt-1 w-full border-gray-200 focus:border-primary  h-9 px-2 "
        />
      </Form.Item>
      <Form.Item
        name={`new_password`}
        label={"New password"}
        className="w-full"
        labelCol={{ span: 24 }}
        rules={[
          {
            required: true,
            message: "Enter new password!",
          },
          {
            whitespace: true,
            message: "Field cannot contain only blank spaces",
          },
        ]}
      >
        <Input.Password
          placeholder="Enter new password"
          name="new_password"
          className="outline-none text-xs rounded-none border mt-1 w-full border-gray-200 focus:border-primary  h-9 px-2 "
        />
      </Form.Item>{" "}
      <Form.Item
        name={`confirm_new_password`}
        label={"Confirm Password"}
        labelCol={{ span: 24 }}
        className="w-full"
        dependencies={["new_password"]}
        rules={[
          {
            required: true,
            message: "Please confirm your password!",
          },
          { validator: validatePassword },
          {
            whitespace: true,
            message: "Field cannot contain only blank spaces",
          },
        ]}
      >
        <Input.Password
          placeholder="Confirm your password"
          name="confirm_new_password"
          className="outline-none text-xs rounded-none border mt-1 w-full border-gray-200 focus:border-primary  h-9 px-2 "
        />
      </Form.Item>{" "}
      <Form.Item>
        <Button
          loading={btnLoading}
          className="w-full font-semibold h-10 bg-primary hover:bg-primaryhover text-white mt-2 border-none"
          htmlType="submit"
        >
          Save
        </Button>
      </Form.Item>{" "}
    </Form>
  </div>
  )
}

export default ChangePassword